import {lazy, Suspense} from "react";
import { PageSkeleton } from "../../customs/skeleton/main";


const Main = lazy(() => import("../../components/application/changeOfMarital/main"));

const ChangeOfMaritalStatus = () => {

    return(
        <Suspense fallback={<PageSkeleton />}>
            <Main/>
        </Suspense>
    )
};

export default ChangeOfMaritalStatus;